import React, { Component } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { FormattedNumber } from 'react-intl';
import FontAwesome from 'react-fontawesome';
import LoginModal from '../login/LoginModal';
import SettingsModal from '../settings/SettingsModal';
import Auth from '../../auth/auth';
import { urls } from '../../services/Server';
import color from '../../config/color';
import observeTickerChanges from '../../services/ticker';

export default class NavigationBar extends Component {
  /*
    This component is a navbar that is rendered on all the pages.
    It contains links to the different sites.
  */

  constructor() {
    super();
    this.loadTicker();
    if (Auth.isLoggedIn()) {
      this.loadUser();
    }

    this.state = {
      isNavExpanded: false,
      showModal: false,
      ticker: 0
    };
  }

  UNSAFE_componentWillMount() {
    // Add listener to the auth state
    Auth.addListener(this.updateAuth.bind(this));
    this.updateAuth();
  }

  componentWillUnmount() {
    Auth.removeListener(this.updateAuth.bind(this));
  }

  loadTicker = () => {
    observeTickerChanges(ticker => {
      this.setState({ ticker });
    });
  };

  setNavExpanded = isNavExpanded => {
    this.setState({ isNavExpanded });
  };

  closeNav = () => {
    this.setNavExpanded(false);
  };

  loadUser() {
    return fetch(urls.user, { credentials: 'include' })
      .then(response => response.json())
      .then(json => {
        this.userLoaded(json);
      });
  }

  userLoaded = user => {
    this.setState({
      user: user.name
    });
  };

  open = () => {
    this.setState({ showModal: true });
    this.closeNav();
  };

  close = () => {
    this.setState({ showModal: false });
  };

  updateAuth = () => {
    this.setState({ isLoggedIn: Auth.isLoggedIn() });
  };

  render() {
    let printedUser;
    if (this.state.isLoggedIn && this.state.user) {
      printedUser = ` | ${this.state.user}`;
    }

    return (
      <Navbar
        id="NavigationBar"
        collapseOnSelect
        fixed="top"
        bg="white"
        expand="lg"
        variant="light"
        onToggle={this.setNavExpanded}
        expanded={this.state.isNavExpanded}
      >
        <Container>
          <Navbar.Brand href="/">
            <FontAwesome name="dollar" />
            <span id="tockwatch">tockwatch</span>{' '}
            <span id="logged-in-as"> {printedUser}</span>
            <span
              className={`ticker-content nav-ticker ${color.getClassName(
                this.state.ticker
              )}`}
            >
              <FormattedNumber // eslint-disable-next-line
                style="percent"
                minimumFractionDigits={2}
                maximumFractionDigits={2}
                value={this.state.ticker}
              />
            </span>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse>
            {this.state.isLoggedIn ? (
              <Nav className="justify-content-end">
                <LinkContainer to="/crypto">
                  <Nav.Item bsPrefix="nav-link" onClick={this.closeNav}>
                    <FontAwesome name="btc" /> Crypto
                  </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/sok">
                  <Nav.Item bsPrefix="nav-link" onClick={this.closeNav}>
                    <FontAwesome name="search" /> Fond/Aksjer
                  </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/portefolje">
                  <Nav.Item bsPrefix="nav-link" onClick={this.closeNav}>
                    <FontAwesome name="list-ul" /> Portefølje
                  </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/stats">
                  <Nav.Item bsPrefix="nav-link" onClick={this.closeNav}>
                    <FontAwesome name="area-chart" /> Statistikk
                  </Nav.Item>
                </LinkContainer>
                <LinkContainer to="/medlemmer">
                  <Nav.Item bsPrefix="nav-link" onClick={this.closeNav}>
                    <FontAwesome name="users" /> Medlemmer
                  </Nav.Item>
                </LinkContainer>
                <Nav.Item bsPrefix="nav-link" onClick={this.open}>
                  <FontAwesome name="cogs" /> Innstillinger
                </Nav.Item>
                <SettingsModal close={this.close} show={this.state.showModal} />
              </Nav>
            ) : (
              <Nav className="justify-content-end">
                <Nav.Item bsPrefix="nav-link" onClick={this.open}>
                  <FontAwesome name="sign-in" /> Logg in
                </Nav.Item>
                <LoginModal close={this.close} show={this.state.showModal} />
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}
